import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";

const eventList = {
  generic: {
    ViewVideosButton: "standard-pdp-image-gallery-view-video-button",
    ThumbnailItem: "standard-pdp-image-gallery-thumbnails-image",
    ThumbnailsUpArrow: "standard-pdp-image-gallery-thumbnails-up-arrow",
    ThumbnailsDownArrow: "standard-pdp-image-gallery-thumbnails-down-arrow",
    ZoomIcon: "standard-pdp-image-gallery-main-image-zoom-icon",
    LeftArrow: "standard-pdp-image-gallery-main-image-left-arrow",
    RightArrow: "standard-pdp-image-gallery-main-image-right-arrow",
    VideoInteraction: "standard-pdp-image-gallery-video-player",
    VideoOverlayInteraction:
      "standard-pdp-image-gallery-video-player-overlay-interaction",
    ModalImageScroll: "standard-pdp-image-gallery-modal-image-scroll",
  },
  imageModal: {
    ThumbnailItem: "standard-pdp-image-gallery-zoom-overlay-thumbnails-image",
    ThumbnailsUpArrow:
      "standard-pdp-image-gallery-zoom-overlay-thumbnails-up-arrow",
    ThumbnailsDownArrow:
      "standard-pdp-image-gallery-zoom-overlay-thumbnails-down-arrow",
    SuperZoom: "standard-pdp-image-gallery-zoom-overlay-super-zoom",
    SuperZoomPan: "standard-pdp-image-gallery-zoom-overlay-super-zoom-pan",
    LeftArrow: "standard-pdp-image-gallery-zoom-overlay-left-arrow",
    RightArrow: "standard-pdp-image-gallery-zoom-overlay-right-arrow",
    CloseModal: "standard-pdp-image-gallery-zoom-overlay-thumbnail-close",
    ClickOnModalImage:
      "standard-pdp-image-gallery-zoom-overlay-click-on-modal-image",
    ModalImageScroll: "standard-pdp-image-gallery-modal-image-scroll",
  },
  videoModal: {
    ThumbnailItem: "standard-pdp-image-gallery-zoom-video-overlay-thumbnail",
    ThumbnailsUpArrow:
      "standard-pdp-image-gallery-zoom-video-overlay-thumbnail-up-arrow",
    ThumbnailsDownArrow:
      "standard-pdp-image-gallery-zoom-video-overlay-thumbnail-down-arrow",
    LeftArrow:
      "standard-pdp-image-gallery-zoom-video-overlay-thumbnail-left-arrow",
    RightArrow:
      "standard-pdp-image-gallery-zoom-video-overlay-thumbnail-right-arrow",
    VideoInteraction: "standard-pdp-image-gallery-zoom-video-overlay-play",
    VideoOverlayInteraction:
      "standard-pdp-image-gallery-zoom-video-overlay-play-overlay",
    CloseModal: "standard-pdp-image-gallery-zoom-video-overlay-thumbnail-close",
  },
};

export const dispatchGalleryMonetateQEvent = (
  eventName: string,
  context?: "generic" | "imageModal" | "videoModal",
  defer?: boolean,
) => {
  const contextEventList: Record<string, string | null> = {
    ...eventList.generic,
    ...(context === "imageModal" ? eventList.imageModal : {}),
    ...(context === "videoModal" ? eventList.videoModal : {}),
  };

  const monetateEventName = contextEventList[eventName];
  if (!monetateEventName) {
    return;
  }

  if (defer) {
    setTimeout(() => {
      dispatchMonetateQEvent(monetateEventName);
    }, 0);
  }

  dispatchMonetateQEvent(monetateEventName);
};
